import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from 'projects/ProjetoBaseAngular/app/base-crud.component';
import { ModelSearch, DataTablesRequest } from 'projects/ProjetoBaseAngular/domain/models';
import { OptionSearchType, SearchType } from 'projects/ProjetoBaseAngular/domain/types';
import { RevistaModel } from '../domain/models';
import { RevistaService } from '../domain/services';
import { RevistaModalComponent } from './revista-modal/revista-modal.component';

@Component({
  selector: 'app-revista',
  templateUrl: './revista.component.html'
})
export class RevistaComponent extends BaseCrudComponent<RevistaModel> implements OnInit {
  @ViewChild('revistaModal') modal: RevistaModalComponent;

  search = new ModelSearch('titulo', OptionSearchType.Contains, SearchType.String);

  selectColumns = [
    { data: 'publicado' },
    { data: 'data' },
    { data: 'titulo' },
    { data: 'edicao' },
    { data: 'arquivoUrl' }
  ];

  constructor(
    injector: Injector,
    readonly revistaService: RevistaService
  ) {
    super(injector, revistaService);
  }

  protected beforeDtRequest(dataTablesParameters: DataTablesRequest): DataTablesRequest {
    const searches = dataTablesParameters.searches || [];
    (this.search.searchTerm) && searches.push(this.search);

    dataTablesParameters.searches = searches;
    return super.beforeDtRequest(dataTablesParameters);
  }

  ngOnInit() {
    super.ngOnInit();    
  }

  abrirLink(model: RevistaModel) {


  }
}
